export default "__VITE_ASSET__f69b136e__"